import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import moment from 'moment-timezone';

const denverClock = document.getElementById("denver-clock");
const userClock = document.getElementById("user-clock");

function updateTime() {
  const now = moment();

  const denver = moment.tz(now, "America/Denver");

  const humanReadable = denver.format('hh:mm:ss A');
  const humanReadableUser = now.format('hh:mm:ss A');

  denverClock.textContent = humanReadable;
  userClock.textContent = humanReadableUser;
}

setInterval(updateTime, 1000);

updateTime();
